
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expert/[...slug]",
      function () {
        return require("private-next-pages/expert/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expert/[...slug]"])
      });
    }
  